module.exports = __webpack_public_path__ + "static/media/model-mission-6.b2e652b3.png";